const BASE_URL = "/checkout-branding";

export const PAGE_URLS = {
  details: BASE_URL,
  edit: `${BASE_URL}/edit`,
};
